// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 国际化
import i18n from './assets/language/index';

// 引入element-ui框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// vuex
import store from './vuex/index.js'

// 自定义插件库封装常用方法
import Plugin from './assets/plugin/index.js'
Vue.use(Plugin)

// 动态修改title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

//复制内容到粘贴板
// import VueClipboard from 'vue-clipboard2'
// Vue.use(VueClipboard)

// 打印机
// import Print from 'vue-print-nb'
// Vue.use(Print)

//cookie
// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)
// 引入公共样式
import './assets/css/reset.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  i18n,
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js